import React from "react";
import { Link } from "react-router-dom";
import { COLORS, TYPOGRAPHY, SPACING } from "../constants/designTokens";

const Breadcrumb = ({ items }) => {
  if (!items || items.length === 0) return null;

  return (
    <nav className="breadcrumb-nav" aria-label="Breadcrumb">
      <style>{`
        .breadcrumb-nav {
          background: ${COLORS.background.white};
          border-bottom: 1px solid ${COLORS.ui.border};
        }
        .breadcrumb-nav .container {
          display: flex;
          align-items: center;
        }
        .breadcrumb {
          list-style: none;
          padding: ${SPACING.sm} 0;
          margin: 0;
          display: flex;
          align-items: center;
          flex-wrap: wrap;
        }
        .breadcrumb-item {
          display: flex;
          align-items: center;
          font-size: ${TYPOGRAPHY.fontSize.sm};
          color: ${COLORS.text.light};
          flex: 0 0 auto;
        }
        .breadcrumb-item:last-child {
          color: ${COLORS.primary.dark};
          font-weight: ${TYPOGRAPHY.fontWeight.semibold};
          cursor: default;
        }
        .breadcrumb-item a {
          color: inherit;
          text-decoration: none;
          transition: color 0.2s ease;
        }
        .breadcrumb-item:not(:last-child) a:hover {
          color: ${COLORS.primary.teal};
          text-decoration: none;
        }
        .breadcrumb-item a:focus {
          outline: 2px solid ${COLORS.primary.teal};
          outline-offset: 2px;
          border-radius: 4px;
        }
        .breadcrumb-separator {
          display: flex;
          align-items: center;
          margin: 0 ${SPACING.xs};
          color: ${COLORS.text.light};
          opacity: 0.45;
        }
        @media (max-width: 576px) {
          .breadcrumb {
            padding: ${SPACING.xs} 0;
            font-size: ${TYPOGRAPHY.fontSize.xs};
          }
        }
      `}</style>

      <div className="container">
        <ol className="breadcrumb">
          {items.map((item, index) => (
            <li key={index} className="breadcrumb-item">
              {index > 0 && (
                <span className="breadcrumb-separator">
                  <svg viewBox="0 0 24 24" fill="currentColor" width="14" height="14">
                    <path d="M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z" />
                  </svg>
                </span>
              )}
              {item.href && index < items.length - 1 ? (
                <Link to={item.href}>{item.label}</Link>
              ) : (
                <span>{item.label}</span>
              )}
            </li>
          ))}
        </ol>
      </div>
    </nav>
  );
};

export default Breadcrumb;
